export enum SignupError {
  UserAlreadyExists,
  Unknown
}
